import gql from "graphql-tag";

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    firstName
    lastName
    email
    emailVerificationTime
    phoneNumberVerificationTime
    phoneNumber
    referrer
    signupInstagramHandle
    connectedInstagramHandle
    instagramToken
    images
    homeCity {
       geonamesId
       name
    }
    locations
    status
    skills
    membership
    instagramTokenRefreshFailedAt
  }
`;

export const LOGIN_USER_FRAGMENT = gql`
  fragment LoginUserFragment on LoginUser {
    token
  }
`;

export const UPDATE_USER_GENERAL_INFORMATION = gql`
  mutation updateUserGeneralInformation($input: UserGeneralInformationInput, $recaptchaToken: String) {
    updateUserGeneralInformation(input: $input, recaptchaToken: $recaptchaToken) {
      ...UserFragment
      auth {
        token
      }      
    }
  }
  ${USER_FRAGMENT}
`;

export const WEB_LOGIN = gql`
  mutation webLogin($email: String, $phoneNumber: String) {
    webLogin(email: $email, phoneNumber: $phoneNumber) {
      ...LoginUserFragment
      token
    }
  }
  ${LOGIN_USER_FRAGMENT}
`;

export const UPDATE_USER_SKILLS = gql`
  mutation updateUserSkills($input: UserSkillsInput) {
    updateUserSkills(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_LOCATIONS = gql`
  mutation updateUserLocations($input: UserLocationsInput) {
    updateUserLocations(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const UPDATE_USER_PHOTOS = gql`
  mutation updateUserPhotos($input: UserPhotosInput) {
    updateUserPhotos(input: $input) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const SEND_PHONE_NUMBER_VERIFY_CODE = gql`
  mutation sendPhoneNumberVerifyCode($webLoginToken: String) {
    sendPhoneNumberVerifyCode(webLoginToken: $webLoginToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const SEND_EMAIL_VERIFY_CODE = gql`
  mutation sendEmailVerifyCode($webLoginToken: String)  {
    sendEmailVerifyCode(webLoginToken: $webLoginToken) {
      id
    }
  }
`;

export const CHECK_PHONE_NUMBER_VERIFY_CODE = gql`
  mutation checkPhoneNumberVerifyCode($code: String, $recaptchaToken: String) {
    checkPhoneNumberVerifyCode(code: $code, recaptchaToken: $recaptchaToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const CHECK_PHONE_NUMBER_VERIFY_CODE_FOR_WEB_LOGIN = gql`
  mutation checkPhoneNumberVerifyCodeForWebLogin($code: String, $recaptchaToken: String, $webLoginToken: String) {
    checkPhoneNumberVerifyCodeForWebLogin(code: $code, recaptchaToken: $recaptchaToken, webLoginToken: $webLoginToken) {
      ...LoginUserFragment
      token
    }
  }
  ${LOGIN_USER_FRAGMENT}
`;

export const CHECK_EMAIL_VERIFY_CODE = gql`
  mutation checkEmailVerifyCode($code: String, $recaptchaToken: String) {
    checkEmailVerifyCode(code: $code, recaptchaToken: $recaptchaToken) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const CHECK_EMAIL_VERIFY_CODE_FOR_WEB_LOGIN = gql`
  mutation checkEmailVerifyCodeForWebLogin($code: String, $recaptchaToken: String, $webLoginToken: String) {
    checkEmailVerifyCodeForWebLogin(code: $code, recaptchaToken: $recaptchaToken, webLoginToken: $webLoginToken) {
      ...LoginUserFragment
      token
    }
  }
  ${LOGIN_USER_FRAGMENT}
`;

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    currentUser {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;

export const EXCHANGE_TOKEN = gql`
  mutation exchangeToken($code: String, $redirectUri: String) {
    exchangeToken(code: $code, redirectUri: $redirectUri)
  }
`;

export const CREATE_SUBSCRIPTION = gql`
  mutation CreateSubscription($paymentMethodId: String!, $priceId: String!) {
    createSubscription(paymentMethodId: $paymentMethodId, priceId: $priceId) {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;
